import { Col } from 'antd'
import * as React from 'react'
import { useQuery } from '@apollo/react-hooks'

import { client as apolloClient } from '../ApolloProvider/ApolloProvider'
import {
  blackListedCountry,
  topListedCountry,
} from '../BrandDashboard/BrandDashboardSettings/config'
import {
  InputLabel,
  StyledRow,
  StyledSelect,
  FormError,
} from '../BrandDashboard/BrandDashboardSettings/BrandDashboardSettings.style'

import { GET_COUNTRIES } from '../../queries/GetCountries'
import { GET_CITIES } from '../../queries/GetCities'
import { topLocations } from '../../helpers/top-locations-helper'
import { fullCityName } from '../../helpers/locationNames'

interface LocationFormProps {
  setCityId?: (e: string) => void
  setCountryId?: (e: string) => void
  error?: boolean
  cityDisplayValue?: string
  countryDisplayValue?: string
  isCoutryDisabled?: boolean
  initialCountryId?: string
}
const LocationForm: React.FC<LocationFormProps> = ({
  setCityId,
  setCountryId,
  error,
  cityDisplayValue,
  countryDisplayValue,
  isCoutryDisabled,
  initialCountryId,
}) => {
  const [cityUuid, setCityUuid] = React.useState('')
  const [countryUuid, setCountryUuid] = React.useState('')

  const { data: citiesData, refetch: refetchCities } = useQuery(GET_CITIES, {
    variables: { countryUuid, pageSize: 100, searchTerm: '' },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })
  const { data: countriesData } = useQuery(GET_COUNTRIES, {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })

  const countiesList = countriesData && countriesData.allCountries
  const filteredCounryData =
    countiesList &&
    countiesList.filter(obj => {
      return !blackListedCountry.some(v => obj.name === v)
    })
  filteredCounryData &&
    topListedCountry
      .slice(0)
      .reverse()
      .map(item => topLocations(item, filteredCounryData))

  const { Option } = StyledSelect

  React.useEffect(
    () => {
      initialCountryId && setCountryUuid(initialCountryId)
    },
    [initialCountryId]
  )

  return (
    <StyledRow type="flex" gutter={24}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <InputLabel>Country</InputLabel>
        <StyledSelect
          error={error && countryUuid === ''}
          className={countryDisplayValue === undefined && countryUuid === '' ? '' : 'filled'}
          name="country"
          disabled={isCoutryDisabled}
          onChange={value => {
            setCountryUuid(value)
            setCountryId && setCountryId(value)
            setCityUuid('')
            refetchCities({
              countryUuid: value,
              pageSize: 12,
              searchTerm: '',
            })
          }}
          value={
            countryDisplayValue === null
              ? undefined
              : countryDisplayValue || countryUuid || undefined
          }
          placeholder="Select a country"
          showSearch
          suffixIcon={
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {filteredCounryData &&
            filteredCounryData.map(country => (
              <Option key={country.uuid} value={country.uuid}>
                {country.name}
              </Option>
            ))}
        </StyledSelect>
        {error && <FormError>Location is required.</FormError>}
      </Col>
      <Col xs={24} sm={24} md={12} lg={12}>
        <InputLabel>City</InputLabel>
        <StyledSelect
          error={error && cityUuid === ''}
          className={cityDisplayValue === undefined && cityUuid === '' ? '' : 'filled'}
          name="city"
          onChange={value => {
            setCityUuid(value)
            setCityId && setCityId(value)
          }}
          onSearch={e => {
            refetchCities({
              countryUuid,
              pageSize: 12,
              searchTerm: e,
            })
          }}
          value={cityDisplayValue === null ? undefined : cityDisplayValue || cityUuid || undefined}
          placeholder="Select a city"
          showSearch
          suffixIcon={
            <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {citiesData &&
            citiesData.findCity &&
            citiesData.findCity.cities &&
            citiesData.findCity.cities.map(city => (
              <Option key={city.uuid} value={city.uuid}>
                {fullCityName(city.name, city.subdivision1Name)}
              </Option>
            ))}
        </StyledSelect>
      </Col>
    </StyledRow>
  )
}

export default LocationForm



// WEBPACK FOOTER //
// ./src/components/LocationForm/LocationForm.tsx